export const isTestUserEmail = (email) => {
    return email?.endsWith("@sink.sendgrid.net") || email?.endsWith("@qawolf.email") || false;
};
//# sourceMappingURL=utils.js.map